import {Component} from '@angular/core';
import {TaxUtilities} from "../../../../../../utils/tax-utilities";
import {CompositionTableHelper} from './utils/composition-table-helper';
import {CompositionOverviewStore} from "./store/composition-overview-store";
import {FilterKeys} from '../../../../common/utils/filter/enums/filter-keys';
import {ErrorCodes} from "../../../../common/enums/states/error-codes";
import {CurrencyPipe, PercentPipe} from "@angular/common";
import {FormsModule} from "@angular/forms";
import {ErrorMessageComponent} from "../../../../common/components/error-message/error-message.component";
import {CompositionGroupingSettingsComponent} from "../../../../../../_shared/composition-grouping";

@Component({
  selector: 'app-composition-overview-table',
  templateUrl: './composition-overview-table.component.html',
  styleUrls: ['./composition-overview-table.component.css'],
  // CommonModule dropped with the last `*ngFor`/`[ngClass]` (CLAUDE.md rule 6) — the two pipes still used are
  // imported standalone.
  imports: [
    FormsModule,
    PercentPipe,
    CurrencyPipe,
    ErrorMessageComponent,
    CompositionGroupingSettingsComponent
  ],
  providers: [CompositionOverviewStore]
})
export class CompositionOverviewTableComponent {
  protected readonly FilterKeys = FilterKeys;
  protected readonly CompositionTableHelper = CompositionTableHelper;
  protected readonly TaxUtilities = TaxUtilities;
  protected readonly ErrorCodes = ErrorCodes;

  constructor(
    public compositionOverviewStore: CompositionOverviewStore
  ) {
  }
}
